import { environment } from '@src/environments/environment';

export const AppSettings = {
  SHOW_START_WIZARD: false,
  SUBSCRIBE: false,
  GOOGLE_WEB_CLIENT_ID:
    '597671875782-20pa8tbj16s1k6v2ln2qvvl3cviiopjs.apps.googleusercontent.com',
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyBaCByLAXHJcwmEbBrcKlnC-EakCRwLxdg',
    authDomain: 'bag2bag-in.firebaseapp.com',
    databaseURL: 'https://bag2bag-in.firebaseio.com',
    projectId: 'bag2bag-in',
    storageBucket: 'bag2bag-in.appspot.com',
    messagingSenderId: '597671875782',
    appId: '1:597671875782:android:359164c51b43e093',
  },
  googleMapApiKey: 'AIzaSyBb9jf9u_1ADp5pkIq40TecLrnqTHG1f60',
};

export const FEATURE_TYPES = {
  SHORTSTAY: 'SHORTSTAY',
  EXTENDEDSTAY: 'EXTENDEDSTAY',
  EXPERIENCES: 'EXPERIENCES',
  PACKAGES: 'PACKAGES',
  GAMES: 'GAMES',
  SHORTSTAY_PACKAGE: 'SHORTSTAY_PACKAGE',
  GIFT_CARD: 'GIFT_CARD',
};

export const MEMBERSHIP_TYPES = {
  BAG2BAG_PREMIUM: 'BAG2BAG_PREMIUM',
  BAG2BAG_TRUE_BELIEVER: 'BAG2BAG_TRUE_BELIEVER',
};

export const DEFAULT_SORTING_FILTER_VALUE: string = String('POPULARITY');

export const WEBHOOK_PAYMENT_ENUM = {
  PAYPAL: 'PAYPAL',
  RAZORPAY: 'RAZORPAY',
  PAYTM: 'PAYTM',
  STRIPE: 'STRIPE',
};

export const STATIC_PAGE_ENUM = {
  ABOUT_US: 'ABOUT_US',
  REFUND_POLICY: 'REFUND_POLICY',
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  CANCELLATION_POLICY: 'CANCELLATION_POLICY',
  TERMS_AND_CONDITION: 'TERMS_AND_CONDITION',
};

export const STATIC_PAGE_TITLES: {
  value: string;
  display: string;
  path: string;
}[] = [
  {
    value: 'REFUND_POLICY',
    display: 'Refund Policy',
    path: '/company/refund-policy',
  },
  {
    value: 'PRIVACY_POLICY',
    display: 'Privacy Policy',
    path: '/company/privacy-policy',
  },
  {
    value: 'CANCELLATION_POLICY',
    display: 'Cancellation Policy',
    path: '/company/cancellation-policy',
  },
  {
    value: 'TERMS_AND_CONDITION',
    display: 'Terms & Conditions',
    path: '/company/terms-and-conditions',
  },
];

export const FirebaseAnalyticsScreens = {
  FORGOT_PASSWORD: 'forgot_password',
  LOGIN: 'login',
  OTP: 'otp',
  SIGN_UP: 'sign_up',
  HOME: 'home',
  SHORTSTAY_SEARCH: 'shortstay_search',
};

export const FirebaseAnalyticsEvents = {
  LOGIN: 'login',
  SIGN_UP: 'sign_up',
  SHORTSTAY_SEARCH: 'shortstay_search',
  SHORTSTAY_SELECT_PROPERTY: 'shortstay_select_item',
  SHORTSTAY_CHECKOUT_BEGIN: 'shortstay_checkout_begin',
  SHORTSTAY_BOOKING_CONFIRMATION: 'shortstay_booking_confirmation',
};

export const NEW_IMAGE_PLACEHOLDERS = {
  hotel: `${environment.imgHost}/new-assets/india/new-app/icons/placeholder-hotel.webp`,
};

/**
 * @deprecated
 */
export const IMAGE_PLACEHOLDERS = [
  'https://static-img.bag2bag.in/new-assets/india/new-app/icons/placeholder_blue.png',

  'https://static-img.bag2bag.in/new-assets/india/new-app/icons/placeholder_green.png',

  'https://static-img.bag2bag.in/new-assets/india/new-app/icons/placeholder_red.png',
];

export const PAGE_TYPES = {
  HOME_PAGE: 'HOME_PAGE',
  FEATURE_HOME_PAGE: 'FEATURE_HOME_PAGE',
  LANDING_PAGE: 'LANDING_PAGE',
  LIST_PAGE: 'LIST_PAGE',
  DETAIL_PAGE: 'DETAIL_PAGE',
  ACTIVITY_DETAIL_PAGE: 'ACTIVITY_DETAIL_PAGE',
  COUPON_PAGE: 'COUPON_PAGE',
  OFFER_PAGE: 'OFFER_PAGE',
  COUPON_DETAIL_PAGE: 'COUPON_DETAIL_PAGE',
  POLICY_PAGE: 'POLICY_PAGE',
  ABOUT_US_PAGE: 'ABOUT_US_PAGE',
  CONTACT_US_PAGE: 'CONTACT_US_PAGE',
  CAREER_PAGE: 'CAREER_PAGE',
  FAQ_PAGE: 'FAQ_PAGE',
  BLOG_PAGE: 'BLOG_PAGE',
  GENERIC_PAGE: 'GENERIC_PAGE',
  CHECKOUT_PAGE: 'CHECKOUT_PAGE',
};

export const COMP_STATES = {
  LOADED: 'LOADED',
};

export const APP_TYPE_CONSTANTS = {
  MOBILE_BROWSER: 'MOBILE_BROWSER',
  WEB_BROWSER: 'WEB_BROWSER',
  MOBILE_APP: 'MOBILE_APP',
};
